// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"735c2002","270":"6cf7b7b2","280":"e4fa44cf","404":"eae9e799","453":"f686cfc2","540":"617b88fe","685":"3cb8b590","855":"7912999b","895":"fedf9c12","928":"b22d2439","937":"5d562368"}[chunkId] + ".chunk.js";
};